const func = $target => {
	var $input = $target.find('input[type="password"]'),
		$btn = $target.find('.btn');

	$btn.on('click', function(e) {
		e.preventDefault;
		if ($input.attr('type') == 'password') {
			$input.attr('type', 'text');
		} else {
			$input.attr('type', 'password');
		}
	});
};

export default func;
